import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {SupplierInvoiceData} from "./supplier-invoice.data";

@Injectable()
export class SupplierInvoiceEntityModel extends EntityModel<SupplierInvoiceData> {
    constructor(injector: Injector) {
        super(injector, SupplierInvoiceData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
